import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sub-title"
}
const _hoisted_2 = {
  key: 0,
  class: "text-align-left font-bold padding-b-1"
}

import BotMessageHeader from '@/components/common/bot-message-header/BotMessageHeader.vue';
import FloatingCard from '@/components/common/floating-card/FloatingCard.vue';
import TaskCard from '@/components/common/task-card/TaskCard.vue';
import { AuthMethods } from '@/models/auth-methods';
import { SuggestionsCategory } from '@/models/chat.models';
import { useAuthStore } from '@/stores/authStore';

interface Props {
  botMessageTitle: string;
  suggestionCategories: SuggestionsCategory[];
  handleSuggestionClick: (suggestion: string) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatSuggestions',
  props: {
    botMessageTitle: {},
    suggestionCategories: {},
    handleSuggestionClick: { type: Function }
  },
  setup(__props: any) {



const { authMethod } = useAuthStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FloatingCard, null, {
    default: _withCtx(() => [
      _createVNode(BotMessageHeader, { title: _ctx.botMessageTitle }, null, 8, ["title"]),
      (_unref(authMethod) === _unref(AuthMethods).FranceMock)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t('chat_suggestions.france_sub_title')), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestionCategories, (category, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "suggestions",
          key: index
        }, [
          (category.category)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(category.category), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.questions, (suggestion, index) => {
            return (_openBlock(), _createBlock(TaskCard, {
              key: index,
              icon: "light-bulb",
              "icon-size": "body-xl",
              description: suggestion,
              onClick: ($event: any) => (_ctx.handleSuggestionClick(suggestion)),
              "fixed-icon-size": false
            }, null, 8, ["description", "onClick"]))
          }), 128))
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})